import type { SelectionContextItem } from './lib'

export type TextSelectionContextItem = Extract<
  SelectionContextItem,
  { selection: { selection_start: number; selection_end: number; selected_text?: string } }
>

export type ChartSelectionContextItem = Extract<
  SelectionContextItem,
  { selection: { chart_id: string; chart_title?: string } }
>

export type AttachmentSelectionContextItem = Extract<
  SelectionContextItem,
  { selection: { attachment_id: string; attachment_title?: string } }
>

export function isTextSelectionContextItem(
  selection: SelectionContextItem,
): selection is TextSelectionContextItem {
  return (
    'selection' in selection &&
    selection.selection != null &&
    'selection_start' in selection.selection &&
    'selection_end' in selection.selection &&
    !('chart_id' in selection.selection) &&
    !('attachment_id' in selection.selection)
  )
}

export function isChartSelectionContextItem(
  selection: SelectionContextItem,
): selection is ChartSelectionContextItem {
  return (
    'selection' in selection && selection.selection != null && 'chart_id' in selection.selection
  )
}

export function isAttachmentSelectionContextItem(
  selection: SelectionContextItem,
): selection is AttachmentSelectionContextItem {
  return (
    'selection' in selection &&
    selection.selection != null &&
    'attachment_id' in selection.selection
  )
}
